import {
    Checkbox,
    Dialog,
    FormControlLabel,
    IconButton,
    MenuItem,
    Select,
    Slide,
    Toolbar,
    Drawer,
    List,
    Box,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

import { WORK_STATUS } from "../../utils/constants";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});
const SearchAdvance = ({
    openSearchAdvance,
    handleCloseSearchAdvance,
    filter,
    setFilter,
}) => {
    // page: 0,
    // size: 30,
    // title: null,
    // from_date: null,
    // to_date: null,
    // status: undefined,
    // work_type: null,
    // permission: undefined,
    // parent_id: null,
    // is_important: null,
    // is_unread: null,
    // assignee: null,
    // const [filter, setFilter] = useState(filter);
    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    // useEffect(() => {
    //     if (!openSearchAdvance) return;
    //     setFilter(filter);
    // }, [openSearchAdvance]);

    const handleChangeFromDate = (newValue) => {
        setFilter({
            ...filter,
            from_date: newValue.format("YYYY-MM-DD"),
        });
    };
    const handleChangeToDate = (newValue) => {
        setFilter({
            ...filter,
            to_date: newValue.format("YYYY-MM-DD"),
        });
    };
    const handleChangeStatus = (event) => {
        setFilter({ ...filter, status: event.target.value });
    };
    const handleChangeImportant = (event) => {
        setFilter({
            ...filter,
            is_important: event.target.checked,
        });
    };
    const handleChangeUnread = (event) => {
        setFilter({
            ...filter,
            is_unread: event.target.checked,
        });
    };
    const handleApply = () => {
        setFilter({ page: 0, size: 10, ...filter });
        handleCloseSearchAdvance();
    };
    const handleReset = () => {
        setFilter({
            ...filter,
            from_date: null,
            to_date: null,
            status: null,
            is_important: null,
            is_unread: null,
        });
    };
    const list = (
        <Box
            sx={{
                width: "335px",
                pt: "50px",
                "& ul": {
                    position: "unset",
                    marginBottom: "70px",
                },
            }}
            role="presentation"
        >
            <div className="px-5 mt-[50px] search-advance">
                <div className="min-h-[calc(100vh-90px)]">
                    <p className="font-semibold text-sm leading-5 text-[#16192C]">
                        Lọc nhanh
                    </p>
                    <p>
                        <FormControlLabel
                            className=""
                            control={<Checkbox />}
                            label="Công việc ưu tiên"
                            onChange={handleChangeImportant}
                            checked={!!filter?.is_important}
                        />
                    </p>
                    <div>
                        <FormControlLabel
                            control={<Checkbox />}
                            label="Công việc chưa đọc"
                            onChange={handleChangeUnread}
                            checked={!!filter?.is_unread}
                        />
                    </div>
                    <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
                        Ngày bắt đầu - kết thúc
                    </p>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="vi"
                    >
                        <div className="flex gap-3">
                            <div className="mt-4">
                                <MobileDatePicker
                                    inputFormat="DD/MM/YYYY"
                                    value={filter?.from_date}
                                    onChange={handleChangeFromDate}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            error={false}
                                            placeholder="DD/MM/YYYY"
                                        />
                                    )}
                                    initialFocusedDate={null}
                                />
                            </div>
                            <div className="mt-4">
                                <MobileDatePicker
                                    inputFormat="DD/MM/YYYY"
                                    // minDate={minDate}

                                    value={filter?.to_date}
                                    onChange={handleChangeToDate}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            error={false}
                                            placeholder="DD/MM/YYYY"
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </LocalizationProvider>
                    <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
                        Trạng thái
                    </p>
                    <div>
                        <Select
                            displayEmpty
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={filter?.status}
                            onChange={handleChangeStatus}
                            fullWidth
                            placeholder="Chọn"
                        >
                            <MenuItem value={null}>Chọn</MenuItem>
                            <MenuItem value={WORK_STATUS.COMPLETE}>
                                Hoàn thành
                            </MenuItem>
                            <MenuItem value={WORK_STATUS.PENDING}>
                                Chưa hoàn thành
                            </MenuItem>
                        </Select>
                    </div>
                </div>
                <div className="sticky bottom-[34px] w-full flex gap-2">
                    <button
                        onClick={handleReset}
                        className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px]"
                    >
                        <div className="font-semibold text-[14px] leading-[22px] px">
                            Nhập lại
                        </div>
                    </button>
                    <button
                        onClick={handleApply}
                        className="text-center text-white rounded bg-primary w-1/2 py-[12px]"
                    >
                        <div className="font-semibold text-[14px] leading-[22px] px">
                            Áp dụng
                        </div>
                    </button>
                </div>
            </div>
        </Box>

    )
    return (
        <Fragment>
            <Drawer anchor={"right"} open={openSearchAdvance} onClose={handleCloseSearchAdvance} >
                {list}
            </Drawer>
        </Fragment>

    );
};

export default SearchAdvance;
